export const WebCloserName = 'Web';
